import { isNil } from "lodash";
import { v4 } from "uuid";
import { Locale } from "../../ui/components/LanguageProvider";
import { bootstrapAndIdentify } from "../common/gainsight";
import localStorage from "../common/localStorage";

export const initializeApp = () => {
    let userId = localStorage.get("userId");

    if (isNil(userId)) {
        userId = v4();
        localStorage.set("userId", userId);
    }

    bootstrapAndIdentify({ user: { id: userId } });

    const language = localStorage.get("language");

    if (isNil(language)) {
        localStorage.set("language", Locale.ItIt);
    }
};
